import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { packagesSettingsActions } from '@/Pages/Settings/modules/PackageSettings/services/reducer';
import { PackageModel } from '@/Models';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';

export function usePackageSettings() {
  const dispatch: AppDispatch = useDispatch();

  const {
    tours: {
      PackageSettings: { Default, Package },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Default.Title,
      steps: [
        {
          content: Default.Step1.Text,
          placement: 'auto',
          target: '#packageTitle',
          title: Default.Step1.Title,
          disableBeacon: true,
          link: Default.Step1.DetailsLink,
        },
        {
          content: Default.Step2.Text,
          placement: 'auto',
          target: '#packageTable',
          title: Default.Step2.Title,
          disableBeacon: true,
          link: Default.Step2.DetailsLink,
        },
        {
          content: Default.Step3.Text,
          placement: 'auto',
          target: '#crudExtended',
          title: Default.Step3.Title,
          disableBeacon: true,
          link: Default.Step3.DetailsLink,
        },
        {
          content: Default.Step4.Text,
          placement: 'auto',
          target: '.dx-toolbar-after',
          title: Default.Step4.Title,
          disableBeacon: true,
          link: Default.Step4.DetailsLink,
          spotlightPadding: 0,
          styles: {
            spotlight: {
              maxWidth: '500px',
            },
          },
        },
        {
          content: Default.Step5.Text,
          placement: 'auto',
          target: '#tableImportButton',
          title: Default.Step5.Title,
          disableBeacon: true,
          link: Default.Step5.DetailsLink,
          styles: {
            spotlight: {
              minWidth: '65px',
            },
          },
        },
        {
          content: Default.Step6.Text,
          placement: 'auto',
          target: '#packageForm',
          title: Default.Step6.Title,
          disableBeacon: true,
          link: Default.Step6.DetailsLink,
        },
      ],
    }),
    [Default],
  );

  const packageTour = useMemo<TourType>(
    () => ({
      id: 'packageTour',
      title: Package.Title,
      before: () => {
        dispatch(packagesSettingsActions.createPackage({} as PackageModel));
      },
      steps: [
        {
          content: Package.Step1.Text,
          placement: 'auto',
          target: '#packageSettingsTitle',
          title: Package.Step1.Title,
          disableBeacon: true,
          link: Package.Step1.DetailsLink,
        },
        {
          content: Package.Step2.Text,
          placement: 'auto',
          target: '#packageModalFields',
          title: Package.Step2.Title,
          disableBeacon: true,
          link: Package.Step2.DetailsLink,
        },
        {
          content: Package.Step3.Text,
          placement: 'auto',
          target: '#packageModalStatus',
          title: Package.Step3.Title,
          disableBeacon: true,
          link: Package.Step3.DetailsLink,
        },
      ],
    }),
    [Package],
  );

  return [pageTour, packageTour];
}
